import { useParams } from 'react-router-dom';
import { Bin } from '@shared/assets/icons';
import { useDelete } from 'library/hooks/events';
import * as st from './styles.module.scss';

interface Props {
  hasTickets: boolean;
}

export const Actions: React.FC<Props> = ({ hasTickets }) => {
  const { id = '' } = useParams<{ id: string }>();
  const { deleteEvent } = useDelete();

  return (
    <>
      {id && (
        <fieldset className={st.wrapper}>
          <Bin />
          <button className={st.btn} type="button" onClick={() => deleteEvent(id, hasTickets)}>
            Удалить мероприятие
          </button>
        </fieldset>
      )}
    </>
  );
};
